import { AirplaneCheckIcon } from './AirplaneCheckIcon';

/**
 * author: Colton Wiscombe
 * id 3771D65E-17FD-41E0-B8E7-D1136B28D672
 * name airplane-check
 * version: 6.2.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/airplane-check.svg
 * tags
 * - Transportation + Flying 
 */
export const AirplaneTickIcon = AirplaneCheckIcon;
export default AirplaneTickIcon